/* 06 お店の紹介（2026-10-02）：日本時間で、扉の札（表 OPEN／裏 準備中・定休日・本日終了）と「営業中／準備中／定休日」を切り替える。状態の横に今日の日付と曜日。
   ・営業時間（data-slots 例 11:00-14:30,17:30-21:00）・ラストオーダー（data-lo 例 14:00,20:30）・定休日（data-closed 例 2,3。0=日）はセクションの設定から
   ・臨時休業・祝日は分からないので反映しない（カードに注意書き）。1分ごとに見直す
   ・カードが画面に入ったら、札が1回ゆれる（動きを減らす設定ではゆらさない）
   ・スマホ（〜749px）では住所・営業時間・定休日をたたむ。PC・タブレットは開いたまま */
(() => {
  const DAY = ['日', '月', '火', '水', '木', '金', '土'];
  const toMin = (s) => { const m = /^(\d{1,2}):(\d{2})$/.exec(s.trim()); return m ? Number(m[1]) * 60 + Number(m[2]) : null; };
  const fmt = (m) => `${Math.floor(m / 60)}:${String(m % 60).padStart(2, '0')}`;
  const tokyoNow = () => {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Tokyo', weekday: 'short', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    const get = (t) => (parts.find((p) => p.type === t) || {}).value;
    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
    return { day, month: Number(get('month')), date: Number(get('day')), min: Number(get('hour')) * 60 + Number(get('minute')) };
  };
  const init = (card) => {
    if (card.dataset.kshopOn) return;
    card.dataset.kshopOn = '1';
    const slots = (card.dataset.slots || '').split(',').map((s) => s.split('-').map(toMin)).filter((s) => s.length === 2 && s[0] != null && s[1] != null && s[0] < s[1]).sort((a, b) => a[0] - b[0]);
    const closed = (card.dataset.closed || '').split(',').map((s) => Number(s.trim())).filter((n) => n >= 0 && n <= 6);
    /* ラストオーダー（営業時間と同じ順。例 14:00,20:30）。LOを過ぎたら札は裏返す */
    const los = (card.dataset.lo || '').split(',').map((s) => (s.trim() ? toMin(s) : null));
    const state = card.querySelector('[data-kshop-state]');
    const when = card.querySelector('[data-kshop-when]');
    const sign = card.querySelector('[data-kshop-sign]');
    const today = card.querySelector('[data-kshop-date]');
    const more = card.querySelector('[data-kshop-more]');
    if (more) {
      const mq = window.matchMedia('(max-width: 749px)');
      const fit = () => { more.open = !mq.matches; };
      fit();
      if (mq.addEventListener) mq.addEventListener('change', fit); else if (mq.addListener) mq.addListener(fit);
    }
    if (!slots.length || !state || !when) return;
    const sec = card.closest('.kshop--card');
    if (sec) sec.classList.add('kshop--live');
    const nextOpenLabel = (day) => {
      for (let i = 1; i <= 7; i += 1) {
        const d = (day + i) % 7;
        if (!closed.includes(d)) return `${i === 1 ? '明日' : `${DAY[d]}曜`} ${fmt(slots[0][0])}から`;
      }
      return '';
    };
    const update = () => {
      const { day, month, date, min } = tokyoNow();
      const dateText = `${month}月${date}日（${DAY[day]}）`;
      if (today && today.textContent !== dateText) today.textContent = dateText;
      let open = false;
      let s;
      let w;
      let back = '準備中';
      if (closed.includes(day)) {
        s = '定休日';
        back = '定休日';
        w = nextOpenLabel(day);
      } else {
        const ci = slots.findIndex(([a, b]) => min >= a && min < b);
        const cur = ci >= 0 ? slots[ci] : null;
        const lo = ci >= 0 ? los[ci] : null;
        const next = slots.find(([a]) => min < a);
        if (cur && lo != null && min >= lo) {
          s = 'ラストオーダー終了';
          if (next) { back = '準備中'; w = `${fmt(next[0])}から`; } else { back = '本日終了'; w = nextOpenLabel(day); }
        } else if (cur) { open = true; s = '営業中'; w = lo != null ? `LO ${fmt(lo)}（${fmt(cur[1])}まで）` : `${fmt(cur[1])}まで`; }
        else if (next) { s = '準備中'; w = `${fmt(next[0])}から`; }
        else { s = '本日の営業は終了'; back = '本日終了'; w = nextOpenLabel(day); }
      }
      if (sign && sign.textContent !== back) sign.textContent = back;
      if (state.textContent !== s) state.textContent = s;
      if (when.textContent !== w) when.textContent = w;
      card.classList.toggle('is-open', open);
      card.classList.toggle('is-closed', !open);
    };
    update();
    setInterval(update, 60000);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      card.classList.add('is-sway');
    }), { threshold: .5 });
    io.observe(card);
  };
  const run = () => document.querySelectorAll('[data-kshop-card]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
